import { render, staticRenderFns } from "./popup-base.vue?vue&type=template&id=5ef90228&scoped=true"
import script from "./popup-base.vue?vue&type=script&lang=js"
export * from "./popup-base.vue?vue&type=script&lang=js"
import style0 from "./popup-base.vue?vue&type=style&index=0&id=5ef90228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef90228",
  null
  
)

export default component.exports